import {LeagueStandingsViewMode} from "./league-standings-view-mode";
import {LeagueRaceType} from "./league-standings-result";

export class LeagueStandingsFilter {
    constructor(
        public viewMode: LeagueStandingsViewMode = LeagueStandingsViewMode.PUBLIC,
        public searchTerm?: string,
        public gender?: number,
        public categoryItemId?: number,
        public raceType?: LeagueRaceType,
        public countries?: number[]
    ) {
        this.viewMode = viewMode;
        this.searchTerm = searchTerm;
        if (raceType == LeagueRaceType.INDIVIDUAL) {
            this.gender = gender;
            this.categoryItemId = categoryItemId;
            this.countries = countries;
        }
        else {
            this.gender = undefined;
            this.categoryItemId = undefined;
            this.countries = undefined;
        }
    }
}